import { Link } from "@/components/common/Link";
const partners = [{
  name: "Global Tech Alliance",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/acrbo_logo.png",
  link: "/CompanyPartnerPage"
}, {
  name: "Strategic Solutions Network",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/red_bluff_chamber_logo.png",
  link: "/CompanyPartnerPage"
}, {
  name: "Innovation Industry Board",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/microsoft_partner_logo.png",
  link: "/CompanyPartnerPage"
}];
export default function OurPartners() {
  return <section data-section-id="107652" id="collaborators" className="bg-background text-foreground border-t border-border">
      <div className="bg-background py-24">
        <div className="container mx-auto px-4 md:px-6">
          <div className="flex flex-col items-center justify-center">
            <p className="mb-12 text-center font-mono text-sm font-semibold tracking-wider text-muted-foreground uppercase">
              Strategic Alliances
            </p>
            
            <div className="flex w-full flex-wrap items-center justify-center gap-12 md:gap-20 lg:gap-24">
              {partners.map((partner, i) => <Link key={partner.name} to={partner.link} className="group relative flex items-center justify-center outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-md" data-index={i} aria-label={`Visit ${partner.name} website`}>
                  <img src={partner.logo} alt={partner.name} className="h-12 w-auto object-contain opacity-60 grayscale transition-all duration-200 ease-in-out group-hover:opacity-100 group-hover:grayscale-0 md:h-16" />
                </Link>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}